import { render, staticRenderFns } from "./LinkKazangPayment.vue?vue&type=template&id=2a65f850&scoped=true"
import script from "./LinkKazangPayment.vue?vue&type=script&lang=js"
export * from "./LinkKazangPayment.vue?vue&type=script&lang=js"
import style0 from "./LinkKazangPayment.vue?vue&type=style&index=0&id=2a65f850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65f850",
  null
  
)

export default component.exports